module.exports = __webpack_public_path__ + "img/47a-mensagens-enviadas-leitura.32183d13.png";